var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconInformative(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 87,
    height: 68,
    viewBox: "0 0 87 68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#273941",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.584 1.678a2.06 2.06 0 0 0-1.525-1.55 2.14 2.14 0 0 0-2.103.627c-12.407 13.55-20.573 16.808-26.301 18.13l-16.38 3.782C3.793 24.164-.271 30.629 1.219 37.08l1.003 4.346c1.49 6.45 7.976 10.48 14.46 8.984l8.62-2.006 13.032 18.173c.5.712 1.328 1.04 2.135.854.046-.011.33-.13.381-.165.958-.68 1.095-1.547.432-2.503L28.994 47.567l4.049-.935c19.957-4.607 30.548 4.02 31.03 4.42a2.11 2.11 0 0 0 2.454.208 2.103 2.103 0 0 0 .963-2.265L56.584 1.678z",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.259 34.922l-4.274-18.513c4.403.646 8.007 3.566 8.961 7.698.985 4.09-1.013 8.303-4.687 10.815z",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.263 21.267c-.465.115-2.708.651-6.729 1.606-6.465 1.711-9.292 8.364-8.48 13.231.42 1.709.773 3.772 1.251 5.714.817 3.958 5.88 9.864 13.185 8.808a142.61 142.61 0 0 0 7.92-1.821l-7.147-27.538z",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.308 18.8l-8.274 1.91c-1.174.272-1.926 1.35-1.681 2.41.245 1.06 1.393 1.7 2.567 1.428l8.274-1.91c1.175-.271 1.926-1.348 1.682-2.41-.249-1.075-1.393-1.699-2.568-1.427zM70.03 16.849c.51.678 1.432.962 2.298.762.265-.06.519-.17.766-.31l7.536-4.756c1.023-.65 1.312-1.895.642-2.785-.67-.89-2.038-1.088-3.06-.437l-7.537 4.757c-1.008.63-1.298 1.875-.645 2.769zM84.403 28.559l-8.853-.974c-1.203-.137-2.344.64-2.557 1.734-.212 1.094.593 2.085 1.796 2.222l8.854.973c.286.034.558.004.823-.057.865-.2 1.568-.86 1.73-1.693.215-1.077-.59-2.069-1.793-2.205z",
    opacity: 0.4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInformative);
export default __webpack_public_path__ + "static/media/icon-informative.f0abd1b9ecc98b3ee1cfa86111d17d58.svg";
export { ForwardRef as ReactComponent };